<template>
    <router-view class="w-100 h-100 p-0 m-0" :style="eventStyle"/>
    <ConnectionOverlay />
    <ManagerJoinBadge />
    <!--Loading v-else></Loading-->
    <!-- Modal sound settings -->
    <!--div class="modal modal fade" id="modalSoundSettings" tabindex="-1" aria-labelledby="modalSoundSettings" aria-hidden="true" data-backdrop="">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Permitir reproducir sonido</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <span>¿Esta seguro que desea reproducir sonido?</span>
                </div>
                <div class="modal-footer">
                    <div class="w-100 d-flex justify-content-end align-items-center">
                        <button type="button" class="btn btn-secondary float-end" data-bs-dismiss="modal">Cerrar</button>
                        <button type="button" class="btn btn-primary ms-2 float-end" @click="">Continuar</button>
                    </div>
                </div>
            </div>
        </div>
    </div-->
    <template v-if="$store.state.game.user">
        <div v-if="$store.state.game.user.role == utils.USER_ROLES.MANAGER" class="w-100 h-100 position-absolute top-0 start-0" style="pointer-events: none"></div>
    </template>
    <div class="position-absolute bottom-0 end-0 bg-dark text-white" id="app-version">
        {{ version }}
    </div>
</template>

<script>
import utils from '../../shared/utils'
import { activeEvent, brandingStyle } from '@/utils/event-branding'
import Loading from '@/components/Loading.vue'
import ConnectionOverlay from '@/components/ConnectionOverlay.vue'
import ManagerJoinBadge from '@/components/ManagerJoinBadge.vue'
import { onMounted, onBeforeUnmount } from 'vue'
import { startScreenWakeLock } from '@/utils/screen-wake-lock'
export default {
    computed: {
        eventStyle() {
            const event = activeEvent(this.$store.state.game);
            return event ? brandingStyle(event.branding) : {};
        },
    },
    setup(){
        let stopScreenWakeLock;
        onMounted(() => { stopScreenWakeLock = startScreenWakeLock(); });
        onBeforeUnmount(() => { if (stopScreenWakeLock) stopScreenWakeLock(); });
    },
    components: {
        Loading,
        ConnectionOverlay,
        ManagerJoinBadge
    },
    data(){
        return {
            utils: utils,
            fs: false,
            logo_interval: null,
            version: process.env.VUE_APP_VERSION
        };
    },
    unmounted(){
        if(this.logo_interval != null)
            clearInterval(this.logo_interval);
    },
    mounted(){        
        console.log(process.env.VUE_APP_VERSION)
        if(this.logo_interval != null)
            clearInterval(this.logo_interval);
        
        this.logo_interval = setInterval(function(){
            if(window.store.state.game.logos){
                window.store.state.logo++;
                if(window.store.state.logo > window.store.state.game.logos.length-1)
                {
                    window.store.state.logo = 0;
                }
            }
        }.bind(this), 8000);

        // Sounds settings modal
    }
}
</script>

<style>
    html, body, #app{
        width: 100%;
        height: 100%;
        user-select: none;
    }

    :root
    {
        touch-action: pan-x pan-y;
        height: 100% 
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .debug{
        max-height: 300px;
    }

    /**
     * Common css
     */

    #title-region{
      	font-family: "Archivo", sans-serif;
        font-size: 3.5vw !important;
    }

    #text-region{
        font-family: "Public Sans", sans-serif; font-weight: 700;
        overflow-wrap: break-word !important;
        /* clamp() instead of a fixed vw so it doesn't shrink too far on a
           narrow screen or run away too big on a wide one. */
        font-size: clamp(1.25rem, 2.2vw, 1.9rem);
    }
    #text-region>button{
        font-family: "Public Sans", sans-serif; font-weight: 700;
        font-size: 1.5vw !important;
        overflow-wrap: break-word !important;
    }

    .team-name{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        letter-spacing: 0.04em;
        font-size: 0.85vw !important;
        text-transform: uppercase;
        background-color: var(--vc-paper-50);
        color: var(--vc-ink-900) !important;
    }

    .team-text{
        font-family: "Archivo", sans-serif;
    }

    #logos {
        max-width: 23vw;
    }

    #logos img{
        height: auto;
        max-height: 150px;
    }

    .input-color{
        width: 100px;
        max-width: 100px;
    }

    .text-score, .name{
        font-family: "Archivo", sans-serif;
    }

    .loading-text{
        font-family: "Archivo", sans-serif;
    }

    .custom-background{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        /* Purely decorative, empty in every view - without this it can end
           up stacked above sibling content (depends on whether that view's
           root establishes its own stacking context) and silently swallow
           clicks meant for whatever's drawn over it. */
        pointer-events: none;
    }

    .badge-activity-type {
        --bs-badge-color: var(--vc-text-600);
        background-color: transparent !important;
        border: 1.5px solid var(--vc-line);
        border-radius: 4px;
        color: var(--vc-text-600) !important;
        font-weight: 700;
    }

    .guesswapp-panel
    {
        display: flex;
        flex-direction: column;
        height: 100vh;
    }

    .flex-1{
        flex: 1;
    }

    .img-team-av, .img-team-av svg, .img-team-av img{
        width: 40px !important;
        height: 40px !important;
        border-radius: 10px;
    }

    .img-av
    {
        width: 80px !important;
        height: 80px !important;
    }

    .text-team-av text
    {
        width: 15vw;
        height: 15vw;
        border-radius: 10px;
    }

    .team-score{
        height: 30px !important;
        border-radius: 5px;
        font-size: 10px;
    }

    #app-version{
        font-size: 10px;
        opacity: 0.3;
        padding: 2px;
    }

    .usr
    {
        border: 4px solid var(--vc-line-strong);
    }

    /* Role border colors (.usr-admin, .usr-player, .usr-manager, .usr-guest,
       .usr-assistant) live in assets/scss/custom.scss alongside the rest of
       the design tokens. */

</style>
